'use strict';

import './mx-grid-actions-panel/mx-grid-actions-panel.component';
import MxGenericGridComponent from './mx-generic-grid/mx-generic-grid.component';
import MxExecutorGridComponent from './mx-executor-grid.component';
import MxGridHelperService from './mx-grid-helper.service';
import { gridEnums } from './GridEnums';
import MxGridActionsPanelComponent from './mx-grid-actions-panel/mx-grid-actions-panel.component';
import MxGridSettingsPanel from './mx-grid-settings-panel/mx-grid-settings-panel.component';
import MxGridControlPanelComponent from './mx-grid-control-panel/mx-grid-control-panel.component';
import MxGridRenderComponent from './mx-grid-render/mx-grid-render.component';
import MxGridSelectionPickerComponent from './mx-grid-selection-picker/mx-grid-selection-picker.component';
import BaseGridGridFactory from './grids/mx-base-grid';
import DynamicGridGridFactory from './grids/mx-dynamic-grid';
import MultiFragmentGridGridFactory from './grids/mx-multifragment-grid';
import ObjectsGridGridFactory from './grids/mx-objects-grid';
import ObjectsDeprecatedGridGridFactory from './grids/mx-objects-grid-deprecated';
import RelationsGridGridFactory from './grids/mx-relations-grid';

export default angular
	.module('mx.sb.ExecutorGrid', [])
	.value('mx.SolutionBuilderAgent.GridEnums', gridEnums)
	.service('mx.SolutionBuilderAgent.MxGridHelperService', MxGridHelperService)
	.component('mxGenericGridNew', MxGenericGridComponent)
	.component('mxExecutorGrid', MxExecutorGridComponent)
	.component('mxGridActionsPanel', MxGridActionsPanelComponent)
	.component('mxGridSettingsPanel', MxGridSettingsPanel)
	.component('mxGridControlPanel', MxGridControlPanelComponent)
	.component('mxGridRender', MxGridRenderComponent)
	.component('mxGridSelectionPicker', MxGridSelectionPickerComponent)
	.factory('mx.SolutionBuilderAgent.BaseGrid', BaseGridGridFactory)
	.factory('mx.SolutionBuilderAgent.DynamicGrid', DynamicGridGridFactory)
	.factory('mx.SolutionBuilderAgent.MultiFragmentGrid', MultiFragmentGridGridFactory)
	.factory('mx.SolutionBuilderAgent.ObjectsGrid', ObjectsGridGridFactory)
	.factory('mx.SolutionBuilderAgent.ObjectsDeprecatedGrid', ObjectsDeprecatedGridGridFactory)
	.factory('mx.SolutionBuilderAgent.RelationsGrid', RelationsGridGridFactory).name;
